import {
  bl_fi_mst_pricing_scheme_exts_RowClass,
  bl_fi_mst_pricing_scheme_hdr_RowClass
} from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class PricingSchemeContainerModel extends BaseContainerModel {
  bl_fi_mst_pricing_scheme_hdr: bl_fi_mst_pricing_scheme_hdr_RowClass = new bl_fi_mst_pricing_scheme_hdr_RowClass();
  bl_fi_mst_pricing_scheme_exts: bl_fi_mst_pricing_scheme_exts_RowClass[] = [];
}

export class PricingSchemeQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  txn_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  param_code: string;
  value_string: string;
}
